 
 
 
 
 

import { User } from "./types";
import { ChatActions } from "../chats/types";
import { DiscussionActions } from "../../types/discussion-actions";
import { DiscussionCommentActions } from "../../types/discussion-comment-actions";
import { ProfileActions } from "../profile/actions";

export function users(
    state: { [id: string]: User } = {},
    action:
        | DiscussionActions
        | DiscussionCommentActions
        | ChatActions
        | ProfileActions
) {
    switch (action.type) {
        case "discussions/fetch-success":
        case "chats/fetch-success":
        case "discussions/loadmore-success":
        case "discussions/create-success":
        case "discussion-comments/create-success":
        case "discussion-comments/fetch-success":
            if (action.data.entities.users) {
                return updateUsers(state, action.data.entities.users);
            }
            return state;

        case "profile/fetch-success":
        case "profile/update-success":
            return {
                ...state,
                [action.data.id]: {
                    id: action.data.id,
                    full_name: action.data.display_name,
                    avatar_url: action.data.avatar_url,
                    updated_at: action.data.updated_at,
                    preferred_name: action.data.preferred_name,
                },
            };

        case "chats/chat-user":
            return {
                ...state,
                [action.data.id]: action.data,
            };

        default:
            return state;
    }
}

function updateUsers(
    state: { [id: string]: User } = {},
    users: { [id: string]: User }
) {
    for (const [key, value] of Object.entries(users)) {
        if (!state[key] || state[key].updated_at === value.updated_at) {
            state = {
                ...state,
                [key]: value,
            };
        }
    }

    return state;
}
